import { format } from "date-fns";
import axiosInstance from "../../../../axiosInstance";
import { error, info, success } from "../../../../store/notification/actions";

export async function getInventoryDashboardRecords(
  user_id,
  store_id,
  from_date,
  to_date,
  supplier_id
) {
  return await axiosInstance
    .post("/inventory/getInventoryDashboardRecords", {
      user_id: user_id,
      store_id: store_id,
      from_date: format(from_date, "yyyy-MM-dd"),
      to_date: format(to_date, "yyyy-MM-dd"),
      supplier_id,
    })
    .then((response) => {
      if (response && response.data && response.data.status === "success") {
        return response.data.data;
      } else {
        return "";
      }
    })
    .catch((err) => {});
}

export const getStores = (userId) => {
  return axiosInstance
    .get(`/store/getStores?user_id=${userId}`)
    .then((res) => {
      success("Loaded successfully!!!");
      if (res?.data?.status === "success") {
        if (res.data.data.length > 0) {
          return { error: false, message: "", data: res.data.data };
        } else {
          error("No Pharmacy Found!!!");
          return { error: false, message: "", data: [] };
        }
      } else {
        error(res.data.error[0].message);
        return {
          message: res.data.error[0].message,
          hasError: true,
          data: "",
        };
      }
    })
    .catch((err) => {
      error(err.response.data.error[0].message);
      return {
        message: err.response.data.error[0].message,
        hasError: true,
        data: "",
      };
    });
};

export const deleteStore = (data) => {
  return axiosInstance
    .post("/store/deleteStore", data)
    .then((res) => {
      if (res.data.status === "success") {
        success("Pharmacy deleted Successfully...");
        return {
          message: "",
          hasError: false,
          data: "Pharmacy Deleted Successfully",
        };
      }
    })
    .catch((err) => {
      const errorMessage = err.response?.data?.error[0]?.message;
      errorMessage(errorMessage);
      return {
        message: errorMessage,
        hasError: true,
        data: "",
      };
    });
};

export const editStore = (data) => {
  return axiosInstance
    .post("/store/editStore", {
      user_id: data.userId,
      store_id: data.storeid,
      store_name: data.storename,
      store_alias: data.store_alias,
      street1: data.street1,
      street2: data.street2,
      state: data.state.optionname,
      city: data.city.optionname,
      country: data.country.optionname,
      zipcode: data.zipcode,
      store_landline: data.storelandline,
      store_tax_number: data.storetaxnumber,
    })
    .then((res) => {
      if (res.data.status === "success") {
        success("Pharmacy edited Successfully...");
        return {
          message: "",
          hasError: false,
          data: res.data.data,
        };
      }
    })
    .catch((err) => {
      const errorMessage = err.response?.data?.error[0]?.message;
      error(errorMessage);
      return {
        message: errorMessage,
        hasError: true,
        data: "",
      };
    });
};

export const getUserProfile = (userId) => {
  info("Loading details ...");
  return axiosInstance
    .get(`/user/getUserProfile?user_id=${userId}`)
    .then((res) => {
      if (res?.data?.status === "success") {
        if (res.data.data !== null) {
          success("Loaded successfully !!!");
          return { error: false, message: "", data: res.data.data };
        } else {
          error("Invalid user !!!");
          return { error: false, message: "", data: [] };
        }
      } else {
        error(res.data.error[0].message);
        return {
          message: res.data.error[0].message,
          hasError: true,
          data: "",
        };
      }
    })
    .catch((err) => {
      error(err.response.data.error[0].message);
      return {
        message: err.response.data.error[0].message,
        hasError: true,
        data: "",
      };
    });
};

export async function editUserProfile(data) {
  if (data != null) {
    info("Saving Account details ...");
    return await axiosInstance
      .post("/user/editUserProfile", {
        userid: data.userId,
        firstname: data.firstName,
        lastname: data.lastName,
        mobileno: data.mobileNo,
        profilepic: data.profilePic,
      })
      .then((response) => {
        if (response.data.data !== null) {
          success("Account details updated Successfully!!!");
          return response.data.data;
        }
      })
      .catch((err) => {
        error(err.response.data.error[0].message);
        return err.response.data;
      });
  } else {
    error("Internal error occurred");
  }
}

export async function getUserDetails(params) {
  if (params != null) {
    return await axiosInstance
      .get("/employee/getUserDetails", {
        params: params,
      })
      .then((response) => {
        if (response.data.data !== null) {
          success("User details loaded Successfully!!!");
          return response.data.data;
        }
      })
      .catch((err) => {
        error(err.response.data.error[0].message);
        return err.response.data;
      });
  } else {
    error("Internal error occurred");
  }
}

export const getStoreProfileDetails = (storeId) => {
  return axiosInstance
    .get(`/store/getStoreProfileDetails?store_id=${storeId}`)
    .then((res) => {
      success("Pharmacy Details Loaded successfully!!!");
      if (res?.data?.status === "success") {
        if (res.data.data.length > 0) {
          return { error: false, message: "", data: res.data.data };
        } else {
          error("No Pharmacy Found!!!");
          return { error: false, message: "", data: [] };
        }
      } else {
        error(res.data.error[0].message);
        return {
          message: res.data.error[0].message,
          hasError: true,
          data: "",
        };
      }
    })
    .catch((err) => {
      error(err.response.data.error[0].message);
      return {
        message: err.response.data.error[0].message,
        hasError: true,
        data: "",
      };
    });
};

export async function getPurchaseDashboard(store_id, year) {
  return await axiosInstance
    .post("/dashboard/getPurchaseDashboard", {
      store_id: store_id,
      year: year,
    })
    .then((response) => {
      if (response && response.data && response.data.status === "success") {
        return response.data.data;
      } else {
        return "";
      }
    })
    .catch((err) => {});
}

export async function getPurchaseDashboardSupplier(store_id, fromDate, toDate) {
  return await axiosInstance
    .post("/dashboard/getPurchaseDashboardSupplier", {
      store_id: store_id,
      from_date: format(fromDate, "yyyy-MM-dd"),
      to_date: format(toDate, "yyyy-MM-dd"),
    })
    .then((response) => {
      if (response && response.data && response.data.status === "success") {
        return response.data.data;
      } else {
        return "";
      }
    })
    .catch((err) => {});
}

export async function getSupplierPurchaseData(
  store_id,
  startDate,
  endDate,
  supplier
) {
  return await axiosInstance
    .post("/dashboard/getSupplierPurchaseData", {
      store_id: store_id,
      from_date: format(startDate, "yyyy-MM-dd"),
      to_date: format(endDate, "yyyy-MM-dd"),
      supplier,
    })
    .then((response) => {
      if (response && response.data && response.data.status === "success") {
        return response.data.data;
      } else {
        return "";
      }
    })
    .catch((err) => {});
}

export async function getCategory(store_id, year) {
  return await axiosInstance
    .post("/dashboard/getCategories", {
      store_id: store_id,
    })
    .then((response) => {
      if (response && response.data && response.data.status === "success") {
        return response.data.data;
      } else {
        return "";
      }
    })
    .catch((err) => {});
}

export async function getLatestPurchaseDashboardDetails(store_id) {
  return await axiosInstance
    .post("/dashboard/getLatestPurchaseDashboardDetails", {
      store_id: store_id,
    })
    .then((response) => {
      if (response && response.data && response.data.status === "success") {
        return response.data.data;
      } else {
        return "";
      }
    })
    .catch((err) => {});
}
